module.exports = __webpack_public_path__ + "static/step.b92c7c8c.jpg";